import { Col } from 'react-bootstrap'

function ActionButton(props) {
  const { column = 8, children } = props
  return (
    <Col
      md={column}
      className="d-flex flex-row justify-content-end gap-2 align-items-center"
      style={{ height: '30px' }}
    >
      {children}
    </Col>
  )
}

export default ActionButton
